import { openFinPromisify } from 'utils'

export interface WindowService {
  createWindow(options: fin.WindowOption): Promise<fin.OpenFinWindow>
  findWindow(name: string): Promise<fin.OpenFinWindow | undefined>
}

export const openFinWindowService = {
  createWindow(options: fin.WindowOption): Promise<fin.OpenFinWindow> {
    return new Promise((resolve, reject) => {
      const win: fin.OpenFinWindow = new fin.desktop.Window(
        {
          autoShow: true,
          frame: false,
          shadow: true,
          name: options.name + new Date().toString(),
          ...options
        },
        () => resolve(win),
        (err: any) => reject(err)
      )
    })
  },
  async findWindow(name: string): Promise<fin.OpenFinWindow | undefined> {
    const application = await fin.desktop.Application.getCurrent()
    const getChildWindowsAsync = openFinPromisify(application.getChildWindows, application)
    const childWindows = await getChildWindowsAsync()
    return childWindows.find(child => child.name === name)
  }
}

export const browserWindowService = {
  createWindow(_options: fin.WindowOption): Promise<fin.OpenFinWindow> {
    throw new Error('Not implemented')
  },
  findWindow(_name: string): Promise<fin.OpenFinWindow | undefined> {
    return Promise.resolve(undefined)
  }
}
